/* La regla del contador de infracciones (#118, pedido de Erick). UN LUGAR.
 *
 * El pedido fue «4.ª infracción → apercibimiento → suspensión». Esto le pone
 * consecuencias laborales a un contador, así que la regla está escrita ANTES
 * que cualquier pantalla — y las dos decisiones que el pedido no traía se
 * tomaron así, como DEFAULTS que Erick puede cambiar:
 *
 *   · LA VENTANA ES DE 12 MESES CORRIDOS, no año calendario. Con año
 *     calendario, tres infracciones en diciembre y dos en enero serían dos
 *     contadores de tres y dos — cinco en sesenta días sin llegar nunca a
 *     cuatro. Corridos, la historia reciente pesa siempre igual.
 *
 *   · EL CONTADOR SE REINICIA CON LA SANCIÓN (apercibimiento o suspensión):
 *     sólo cuentan las infracciones POSTERIORES a la última. Sin el reinicio,
 *     la 5.ª infracción de alguien ya apercibido volvería a dar «corresponde
 *     apercibimiento» por las mismas cuatro de antes.
 *
 * Y LO QUE EL CONTADOR NO HACE, A PROPÓSITO: sancionar. Llegar a 4 enciende
 * el aviso — acá y por mail a Erick —; el apercibimiento y la suspensión los
 * REGISTRA una persona con su clic, que es la firma. Un contador que
 * suspende solo es un contador que puede suspender por un dato mal cargado
 * (está en el ticket, y vale también para el aviso: avisa, no ejecuta).
 *
 * Las anuladas no cuentan, ni infracciones ni sanciones: anular no borra,
 * pero lo anulado dejó de valer.
 */

export const VENTANA_MESES = 12;
export const UMBRAL = 4;

const vivas = (filas) => (filas || []).filter((f) => !f.anulado_en);

/* La fecha desde la que se cuenta: `hoy` menos la ventana, en ISO. */
export function corteVentana(hoy) {
  // Al mediodía UTC y con aritmética UTC: con la hora local de la máquina,
  // el corte podía caer un día corrido según desde dónde se abriera el hub.
  const d = new Date(String(hoy).slice(0, 10) + "T12:00:00Z");
  d.setUTCMonth(d.getUTCMonth() - VENTANA_MESES);
  return d.toISOString().slice(0, 10);
}

/* El estado del contador de UNA persona.
 *
 * Devuelve las que cuentan (ordenadas de vieja a nueva), el total, si ya
 * corresponde apercibimiento, y la fecha de la última sanción — que es el
 * dato que explica por qué una infracción vieja no está contando.
 */
export function estadoDe(infracciones, sanciones, hoy) {
  const inf = vivas(infracciones);
  const san = vivas(sanciones);
  const ultimaSancion =
    san.map((s) => String(s.fecha).slice(0, 10)).sort().at(-1) || null;
  const desde = corteVentana(hoy);
  const cuentan = inf
    .filter((i) => {
      const f = String(i.fecha).slice(0, 10);
      return f >= desde && (!ultimaSancion || f > ultimaSancion);
    })
    .sort((a, b) => (String(a.fecha) < String(b.fecha) ? -1 : 1));
  return {
    cuentan,
    total: cuentan.length,
    corresponde: cuentan.length >= UMBRAL,
    ultimaSancion,
  };
}
